export const backgroundColorToTileProps: Record<string, { variant?: "primary" | "secondary"; color: string }> = {
  default: { color: "default" },
  info: { color: "info" },
  success: { color: "success" },
  primary: { color: "primary" },
  error: { color: "error" },
  "primary-primary": { variant: "primary", color: "primary" },
  "primary-blue": { variant: "primary", color: "blue" },
  "primary-green": { variant: "primary", color: "green" },
  "secondary-primary": { variant: "secondary", color: "primary" },
  "secondary-blue": { variant: "secondary", color: "blue" },
  "secondary-green": { variant: "secondary", color: "green" },
  "secondary-info": { variant: "secondary", color: "info" },
  "secondary-success": { variant: "secondary", color: "success" },
  "secondary-error": { variant: "secondary", color: "error" }
}
